import React from 'react';

const NotFoundPage: React.FC = () => {
  return <h1>404 - Not Found</h1>;
};

export default NotFoundPage;
